export default __webpack_public_path__ + "static/media/soroush-karimi.620dc9e9.jpg";